export default __webpack_public_path__ + "static/splash-93c15977a259a227907894042145ceed.svg";